const ProducerIntent = () => import('@/pages/producer_intent/ProducerIntent.vue');

const routes = [
  {
    path: '/producer_intent/',
    meta: {
      id: 'ProducerIntent',
      title: 'Producer Intent',
    },
    component: ProducerIntent,
  },
];

export default routes;
